module.exports = "/build/web/images/work-method-paint.4a966dc011417f0c3826d318b3f7e731.png";


//////////////////
// WEBPACK FOOTER
// ./images/work-method-paint.png
// module id = 136
// module chunks = 11